const routes = [
  {
    path: '/parts',
    name: 'Parts',
    component: () => import(/* webpackChunkName: "parts" */ '@/views/parts/PartsMain'),
    children: [
      {
        path: 'list',
        alias: '',
        name: 'PartsList',
        component: () => import(/* webpackChunkName: "parts" */ '@/views/parts/PartsList'),
        prop: true,
        meta: {
          step: ['소모품 설정', '소모품 설정 리스트']
        }
      },
      {
        path: ':seq(\\d+)',
        name: 'PartsView',
        component: () => import(/* webpackChunkName: "parts" */ '@/views/parts/PartsView'),
        prop: true,
        meta: {
          step: ['소모품 설정', '소모품 설정 세부']
        }
      },
      {
        path: 'write',
        name: 'PartsWrite',
        component: () => import(/* webpackChunkName: "parts" */ '@/views/parts/PartsView'),
        prop: true,
        meta: {
          step: ['소모품 설정', '소모품 설정 등록']
        }
      }
    ]
  }
]

export default routes
